// Add your custom JS here.
jQuery(document).ready(function ($) {
  if ($("body").hasClass("home")) {
    // Check if we are on mobile
    var checkmobile = $(".navbar-toggler").css("display");
    if (checkmobile === "block") {
      checkmobile = true;
    } else {
      checkmobile = false;
    }

    $(".projeto-carousel").slick({
      autoplay: false,
      autoplaySpeed: 8000,
      dots: false, // Show dots for navigation
      arrows: true, // Show arrows for navigation
      infinite: false, // Infinite looping
      speed: 500, // Transition speed
      slidesToShow: 2, // Show two slides by default
      slidesToScroll: 1, // Scroll one slide at a time
      nextArrow: $(".ess-arrow-next"),
      prevArrow: $(".ess-arrow-prev"),
      responsive: [
        {
          breakpoint: 768, // Adjust this breakpoint as needed (e.g., for small screens)
          settings: {
            slidesToShow: 1, // Show only one slide on small screens
            slidesToScroll: 1, // Scroll one slide at a time
          },
        },
      ],
    });
    // Toggle classes on hover arrwors
    $(".ess-arrow-next, .ess-arrow-prev, .social-links a").hover(function () {
      $(this).toggleClass("heartbeat");
    });
  } // end if home
});
